import {Direccion} from './direccion';

export class Muestra {
    public _id: string;
    public nombre: string;
    public tipo: string;
    public imagen: string;
    public descontinuada: boolean;
}
